var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"title"},[_vm._v("Articles")]),_vm._l((_vm.articlesPageState.articles),function(article,index){return _c('article-item',{key:index,attrs:{"article":article}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }